<form class="c-form" name="vm.form" #mainForm="ngForm" (ngSubmit)="vm.handleSubmit(mainForm)" [ngStyle]="vm.processing && {'position': 'relative'}" novalidate>
	<div class="o-grid o-grid--wrap@up-to-md">
		<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-hidden@up-to-md o-grid__cell--bottom">
			<p class="c-text" style="margin-bottom:9px;">{{ 'Employees.Invite_Employee' | translate }}</p>
		</div>
	</div>
	<div class="o-grid o-grid--wrap@up-to-md">
		<div class="o-grid__cell o-grid__cell--slim u-no-p">
			<div class="o-grid o-grid--wrap@up-to-md">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-p">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || name.dirty) && name.invalid }">
								<label for="{{ 'name' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Employees.Placeholder.Name' | translate }}</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || name.dirty) && name.invalid }">
								<input type="text" id="{{ 'name-' + vm.uid }}" name="name" #name="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employee.name" maxlength="255" pattern="^\s*\S+(?:\s+\S+){1,}\s*$" required>
								<item-form-error *ngIf="(vm.submitted || name.dirty) && name.invalid" [fieldName]="'Employees.Placeholder.Name' | translate" [error]="name.errors"></item-form-error>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || idcode.dirty) && idcode.invalid }">
								<label for="{{ 'idcode-' + vm.uid }}" class="c-form__label c-form__label--light" [ngClass]="{ 'c-form__label--required': vm.isPersonalCodeRequiredForInvite }">{{ 'Booking.Personal_Code' | translate }}</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || idcode.dirty) && idcode.invalid }">
								<input type="text" id="{{ 'idcode-' + vm.uid }}" name="idcode" #idcode="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employee.idcode" [required]="vm.isPersonalCodeRequiredForInvite" minlength="11" maxlength="12">
								<item-form-error *ngIf="(vm.submitted || idcode.dirty) && idcode.invalid" [fieldName]="'Booking.Personal_Code' | translate" [error]="idcode.errors"></item-form-error>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || email.dirty) && email.invalid }">
								<label for="{{ 'email-' + vm.uid }}" class="c-form__label c-form__label--light c-form__label--required">{{ 'Employees.Placeholder.Email' | translate }}</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || email.dirty) && email.invalid }">
								<input type="email" id="{{ 'email-' + vm.uid }}" name="email" #email="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employee.email" maxlength="255" pattern='^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' required>
								<item-form-error *ngIf="(vm.submitted || email.dirty) && email.invalid" [fieldName]="'Employees.Placeholder.Email' | translate" [error]="email.errors"></item-form-error>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid o-grid--wrap@up-to-md u-ost-md" *ngIf="vm.canUserManuallyAddInsurance">
		<div class="o-grid__cell o-grid__cell--slim u-no-p">
			<div class="o-grid o-grid--wrap@up-to-md">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-p">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m">
								<label for="{{ 'policyNumber-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Employees.Placeholder.PolicyNumber' | translate }}</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m">
								<!-- input type="text" id="{{ 'policyNumber-' + vm.uid }}" name="policyNumber" class="c-form__input c-form__input--sm" [(ngModel)]="vm.invitationExtra.policy.policyNumber" maxlength="32"-->
								<mat-select id="{{ 'policyNumber-' + vm.uid }}"
	                                       name="policyNumber"
	                                       class="mat-select mat-select--sm mat-select--border"
	                                       [(value)]="vm.invitationExtra.policy">
	                                <mat-option id="policyNumber{{$index}}" *ngFor="let policy of vm.activePolicies ; let $index=index" [value]="policy">
	                                    {{ policy.policyNumber }}
	                                </mat-option>
	                            </mat-select>
							</div>
						</div>
						<div [ngStyle]="vm.isInsuranceDatePickerHidden && {'visibility': 'hidden'}" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m">
								<label for="{{ 'activation-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Employees.Placeholder.ActivationDate' | translate }}</label>
							</div>
						</div>
						<div [ngStyle]="vm.isInsuranceDatePickerHidden && {'visibility': 'hidden'}" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m">
								<input-datepicker-new id="{{ 'activationDate-' + vm.uid }}"
                                	name="activationDate"
                                	[(model)]="vm.invitationExtra.activationDate"
                                 	[startDate]="vm.invitationExtra.activationDate"
                                	[hasTimepicker]="false"
                                 	[hasCalendarIcon]="true"
                                 	[minDate]="vm.minDate"
                                	[isSmall]="true"
                                	[isSingleDate]="true"
                                	[isRequired]="false"></input-datepicker-new>
							</div>
						</div>
						<div style="visibility:hidden;" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m">
								<label for="{{ 'terminationDate-' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Employees.Placeholder.TerminationDate' | translate }}</label>
							</div>
						</div>
						<div style="visibility:hidden;" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m">
								<input-datepicker-new id="{{ 'terminationDate-' + vm.uid }}"
                                	name="terminationDate"
                                	[(model)]="vm.invitationExtra.terminationDate"
                        			[startDate]="vm.invitationExtra.terminationDate"
                                    [hasTimepicker]="false"
                                    [hasCalendarIcon]="true"
                                    [minDate]="vm.minDate"
                                    [isSmall]="true"
                                    [isSingleDate]="true"
                                    [isRequired]="false"></input-datepicker-new>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid o-grid--wrap@up-to-md u-ost-md">
		<div class="o-grid__cell o-grid__cell--slim u-no-p">
			<div class="o-grid o-grid--wrap@up-to-md">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-p">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || additionalInfo.dirty) && additionalInfo.invalid }">
								<label for="{{ 'additionalInfo' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Employees.Placeholder.AdditionalInfo' | translate }}</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || additionalInfo.dirty) && additionalInfo.invalid }">
								<input type="text" id="{{ 'additionalInfo-' + vm.uid }}" name="additionalInfo" #additionalInfo="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employee.additionalInfo" maxlength="255">
								<item-form-error *ngIf="(vm.submitted || additionalInfo.dirty) && additionalInfo.invalid" [fieldName]="'Employees.Placeholder.AdditionalInfo' | translate" [error]="additionalInfo.errors"></item-form-error>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid o-grid--wrap@up-to-md u-ost-md">
		<div class="o-grid__cell o-grid__cell--slim u-no-p">
			<div class="o-grid o-grid--wrap@up-to-md">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up u-no-p">
					<div class="o-grid o-grid--wrap">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o1@md-and-up o-grid__cell--bottom">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || additionalInfo2.dirty) && additionalInfo2.invalid }">
								<label for="{{ 'additionalInfo2' + vm.uid }}" class="c-form__label c-form__label--light">{{ 'Employees.Placeholder.AdditionalInfo' | translate }} 2</label>
							</div>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--slim u-no-p@up-to-md o-grid__cell--o3@md-and-up">
							<div class="c-form__group u-no-m" [ngClass]="{ 'c-form__group--error': (vm.submitted || additionalInfo2.dirty) && additionalInfo2.invalid }">
								<input type="text" id="{{ 'additionalInfo2-' + vm.uid }}" name="additionalInfo2" #additionalInfo2="ngModel" class="c-form__input c-form__input--sm" [(ngModel)]="vm.employee.additionalInfo2" maxlength="255">
								<item-form-error *ngIf="(vm.submitted || additionalInfo2.dirty) && additionalInfo2.invalid" [fieldName]="('Employees.Placeholder.AdditionalInfo' | translate) + ' 2'" [error]="additionalInfo2.errors"></item-form-error>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="o-grid o-grid--wrap@up-to-md">
		<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-ost-md o-grid__cell--bottom o-grid__cell--right">
			<button id="submitNewEmployeeButton" type="submit" class="c-button c-button--s1 c-button--fit">{{ 'Employees.Submit' | translate }}</button>
		</div>
	</div>
	<div class="c-form__group u-no-m o-grid__cell--slim">
		<p class="c-text c-text--right u-ost-md">{{ 'Employees.Invite_Employees' | translate | lowerCase }}. {{ 'Employees.Instructions' | translate }} <button id="openInstructionsModalLink" type="button" class="c-button c-button--link" (click)="vm.openInstructionsModal()">{{ 'Employees.Here' | translate | lowerCase }}</button>. {{ 'Employees.Import' | translate }}&nbsp;<label id="openCsvImportLink" for="{{ 'file-' + vm.uid }}" class="c-button c-button--link">{{ 'Employees.Here' | translate | lowerCase }}</label>.</p>
		<input class="u-hidden" id="{{ 'file-' + vm.uid }}" name="file" type="file" accept=".csv" (change)="onFileSelected($event)" [disabled]="vm.processing">
	</div>
	<loader-overlay *ngIf="vm.processing"></loader-overlay>
</form>
